import "./style.scss"

import React from "react"

import { ENV } from "../../constants/env"
import Head from "../head/index"
import Layout from "../layout/index"

const Error = () => (
  <div className="error-page">
    <Head title="tfsports - Gerenciar tickets" />
    <Layout>
      <main>
        <h1>Oops! Something isn't quite right 🚧</h1>
        <p>
          We're sorry, something went wrong. Please <a href={"mailto:" + ENV.HELP_EMAIL}>contact customer support</a>.
        </p>
        {/* <p>
          <img height={100} src={FooterImage} alt="" />
        </p> */}
      </main>
    </Layout>
  </div>
)

export default Error
